import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

import { fetchBrandBasicList } from '@services/commonService';

const Brand = ({ placeholder = 'Brand', identifier = 'brand', isHideChip = false }) => {
	const [brands, setBrands] = useState([]);
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, identifier, identifier);
	const dispatch = useDispatch();

	const fetchBrandList = (params = '') => {
		fetchBrandBasicList(params).then((res) => {
			let tmpBrands = res.map((item) => ({ id: item.id, value: item.name }));
			setBrands(tmpBrands);
		});
	};

	useEffect(() => {
		fetchBrandList();
	}, []);

	const onBrandClick = (brand) => {
		let data = {
			name: identifier,
			type: 'text',
			key: brand.id,
			value: brand.value,
			identifier: identifier,
			isHideChip
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<CustomDropdown
			type="addItem"
			title={placeholder}
			isShowLabel={false}
			onItemClick={onBrandClick}
			onItemSearch={(value) => fetchBrandList(`?name=${value}`)}
			items={brands}
			selectedItem={inputValue?.value || placeholder}
		/>
	);
};

export default Brand;
